import { hexToCSSFilter } from 'hex-to-css-filter';
class SvgGraphicUtils {

    /**
     * Converts a hex color code to a CSS filter string
     * @param hexCode A hex color code in the format of '#RRGGBB'
     * @returns An object containing the CSS filter string
     */
    static hexToFilter(hexCode: string): { filter: string } {
        const result = hexToCSSFilter(hexCode);
        const filter = result.filter.slice(0, -1);
        return { filter }
    }
}
export default SvgGraphicUtils